export default "__VITE_ASSET__a48940e7__"